import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-geo-user',
  templateUrl: './geo-user.component.html',
  styleUrls: ['./geo-user.component.scss']
})
export class GeoUserComponent implements OnInit {

  userForm: FormGroup;
  items: FormArray;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.userForm = new FormGroup({
      items: new FormArray([])
    });
  }
  createItem(): FormGroup {
    return this.formBuilder.group({
      rocode: '',
    });
  }

  addItem(): void {
    this.items = this.userForm.get("items") as FormArray;
    this.items.push(this.createItem());
  }

}
